import { BlocksCarouselItem } from 'blocks-nextjs/blocks-web-components/components/carousel-item/carousel-item';
import React from 'react';
import { createComponent } from '../CustomWrapper/CustomWrapper';

export const CatCarouselItem = createComponent({
  react: React,
  tagName: 'cat-carousel-item',
  elementClass: BlocksCarouselItem,
  events: {}
});
